import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../utils/firebaseConfig';
import '../styles/Login.css';

const getLoginErrorMessage = (errorCode) => {
    switch (errorCode) {
        case 'auth/invalid-credential':
        case 'auth/wrong-password':
        case 'auth/user-not-found':
            return 'The email or password is incorrect.';
        case 'auth/too-many-requests':
            return 'Too many attempts. Try again later.';
        case 'auth/network-request-failed':
            return 'Unable to reach the authentication service.';
        default:
            return 'Login failed. Please try again.';
    }
};

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        setSubmitting(true);

        try {
            await signInWithEmailAndPassword(auth, email.trim().toLowerCase(), password);
            navigate('/dashboard', { replace: true });
        } catch (error) {
            setErrorMessage(getLoginErrorMessage(error.code));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <main className="login-page">
            <section className="login-container" aria-labelledby="login-title">
                <h1 id="login-title">Quik Fix Login</h1>
                <form onSubmit={handleFormSubmit}>
                    <label htmlFor="login-email">Email</label>
                    <input
                        id="login-email"
                        type="email"
                        autoComplete="username"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        required
                    />
                    <label htmlFor="login-password">Password</label>
                    <input
                        id="login-password"
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        required
                    />
                    <button type="submit" disabled={submitting}>
                        {submitting ? 'Signing in…' : 'Login'}
                    </button>
                </form>
                {errorMessage && <p className="error" role="alert">{errorMessage}</p>}
            </section>
        </main>
    );
};

export default Login;
